let service = function (
	$q,
	$rootScope,
	_
) {
	"ngInject";
	
	var service = this;

	this.options = function(attributes, skipId) {
		var filterOptions = [];

		var reduce1 = (previous, current) => {
			return _.intersection(previous,current);
		}

		var reduce2 = (previous, current) => {
			return previous.concat(current)
		}

		for (var i = 0; i < attributes.length; i++) {

			if (skipId !== undefined && attributes[i].id == skipId) {
				continue;
			}

			var activeFilters = attributes[i].options.filter((option) => {
				return option.on;
			})
			.map((option) => option.products);

			if (activeFilters.length > 0) {
				// intersect if MUL, otherwise merge
				if (attributes[i].class === 'MUL') {
					activeFilters = activeFilters.reduce(reduce1);
				} else {
					activeFilters = _.uniq(activeFilters.reduce(reduce2,[]));
				}
				filterOptions.push(activeFilters);
			}
		}

		if (filterOptions.length > 0) {
			return filterOptions.reduce((previous, current) => {
				return _.intersection(previous,current);
			});
		}

		return false;
	}

	this.interface = function(attributes, options, allUids, process) {
		var uids;
		var max = process?0:0;

		var loop = function(attributes, uids) {
			attributes.forEach((attribute) => {

				var attributeOptions;

				if (attribute.class === 'MUL') {
					attributeOptions = service.options(attributes);
				} else {
					attributeOptions = service.options(attributes, attribute.id);
				}

				if (attributeOptions === false) {
					attributeOptions = uids;
				} else {
					attributeOptions = _.intersection(attributeOptions, uids);
				}

				attribute.options.forEach((option) => {
					option.count = _.intersection(option.products, attributeOptions).length;
					option.enabled = option.count > max;
				});
			});
		}

		if (!_.isEmpty(options)) {
			uids = options.reduce(function(a, b) {
				return _.intersection(a, b);
			}, allUids);

			loop(attributes, uids);
		} else {
			loop(attributes, allUids);
		}
	};
};

export default service;


// WEBPACK FOOTER //
// ./app/shared/services/attribute.service.js